import { CooksyLogo } from "@/components/CooksyLogo";
import { CartButton } from "@/components/CartButton";
import { SearchHeader } from "@/components/SearchHeader";
import { useIsMobile } from "@/hooks/use-mobile";
import { useEffect, useState } from "react";
export const HomeHeader = () => {
  const [mounted, setMounted] = useState(false);
  const isMobile = useIsMobile();

  // Ensure we're mounted before rendering to avoid hydration issues
  useEffect(() => {
    setMounted(true);
  }, []);

  // Return a minimal placeholder while not mounted to avoid layout shifts
  if (!mounted) {
    return <header className="bg-background dark:bg-background border-b border-border">
        <div className="container mx-auto px-4">
          <div className="h-16"></div>
        </div>
      </header>;
  }
  if (!isMobile) {
    return <header className="bg-background dark:bg-background border-b border-border">
        <div className="container mx-auto px-4">
          <div className="py-4">
            <SearchHeader />
          </div>
        </div>
      </header>;
  }
  return <header className="bg-background dark:bg-background border-b border-border">
      <div className="container mx-auto px-4">
        
        
        <div className="pb-4 py-[5px]">
          <SearchHeader />
        </div>
      </div>
    </header>;
};